import {useEffect, useState} from 'react';
import {Dialog} from '../../ui/overlays/dialog/dialog';
import {DialogHeader} from '../../ui/overlays/dialog/dialog-header';
import {DialogBody} from '../../ui/overlays/dialog/dialog-body';
import {DialogFooter} from '../../ui/overlays/dialog/dialog-footer';
import {DialogTrigger} from '../../ui/overlays/dialog/dialog-trigger';
import {Button} from '../../ui/buttons/button';
import {Trans} from '../../i18n/trans';

interface AgeVerificationPopupProps {
  isOpen: boolean;
  onAgeVerified: () => void;
  onAgeRejected: () => void;
}

export function AgeVerificationPopup({
  isOpen,
  onAgeVerified,
  onAgeRejected,
}: AgeVerificationPopupProps) {
  const [hasInteracted, setHasInteracted] = useState(false);

  // Prevent closing the dialog by clicking outside or pressing escape
  useEffect(() => {
    if (isOpen && !hasInteracted) {
      // Prevent body scroll when popup is open
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, hasInteracted]);

  const handleYesClick = () => {
    setHasInteracted(true);
    onAgeVerified();
  };

  const handleNoClick = () => {
    setHasInteracted(true);
    onAgeRejected();
  };

  if (!isOpen) return null;

  return (
    <DialogTrigger type="modal" isOpen={isOpen} onClose={() => {}}>
      <Dialog>
        <DialogHeader>
          <div className="text-center">
           
          </div>
        </DialogHeader>
        <DialogBody>
          <div className="text-center">
            <p className="mb-16 text-muted">
              <Trans message="You must be at least 16 years old to create an account on Privatlocker." />
            </p>
            <p className="text-lg font-medium text-main">
              <Trans message="Are you 16 or older?" />
            </p>
          </div>
        </DialogBody>
        <DialogFooter>
          <div className="flex gap-16 w-full">
            <Button
              variant="flat"
              color="primary"
              size="md"
              onClick={handleYesClick}
              className="flex-1"
            >
              <Trans message="Yes, I am 16+" />
            </Button>
            <Button
              variant="outline"
              color="primary"
              size="md"
              onClick={handleNoClick}
              className="flex-1"
            >
              <Trans message="No, I am under 16" />
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </DialogTrigger>
  );
}
